import Swiper from 'swiper';
import { Autoplay } from "swiper/modules";

/* stylelint-disable */

const sliders = document.querySelectorAll( '.js-timeline-slider' );
sliders.forEach(slider => {
  const timelineSlider = new Swiper(slider, {
    modules: [Autoplay],
    speed: 1200,
    loop: true,
    slidesPerView: 'auto',
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
  });

  slider.addEventListener("mouseenter", () => {
    timelineSlider.autoplay.stop();
  });

  slider.addEventListener("mouseleave", () => {
    timelineSlider.autoplay.start();
  });
});
